import React from 'react';
import { Sparkles, Heart, Plus } from 'lucide-react';
import { Button } from './ui/button';
import { stats } from '../mock';
import { useAuth } from '../context/AuthContext';

export default function Hero({ onCreate }) {
  const { requireAuth } = useAuth();
  const start = (t) => { if (requireAuth(`create-${t.toLowerCase()}`)) onCreate && onCreate(t); };

  return (
    <section id="decouvrir" className="relative">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-20">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-black/5 text-[12px] tracking-wide text-neutral-700">
              <Sparkles className="w-3.5 h-3.5 text-[#d97757]" />
              <span className="uppercase font-medium">Solidarité africaine · Éco-responsable</span>
            </div>
            <h1 className="mt-6 text-[clamp(2.4rem,6vw,5.2rem)] leading-[1.02] font-semibold tracking-tight text-[#1a1d1a]">
              Ensemble pour les <span className="serif-italic text-[#d97757]">joies</span>
              <br />
              et les <span className="serif-italic text-[#5a8268]">épreuves</span>.
            </h1>
            <p className="mt-6 text-[17px] leading-[1.65] text-neutral-700 max-w-xl">
              Fodindin, c'est la générosité et la solidarité en mouvement. Créez une cagnotte <span className="font-semibold text-[#d97757]">Joyeuse</span> pour célébrer, ou une cagnotte <span className="font-semibold text-[#5a8268]">Yako</span> pour soutenir. En FCFA, partout en Afrique et au-delà.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button onClick={() => start('Joyeuse')} className="btn-anim rounded-full h-12 px-5 bg-[#d97757] hover:bg-[#c66745] text-white text-[14.5px] font-medium shadow-sm">
                <Plus className="w-4 h-4 mr-1.5" /> Créer une Cagnotte Joyeuse
              </Button>
              <Button onClick={() => start('Yako')} className="btn-anim rounded-full h-12 px-5 bg-[#5a8268] hover:bg-[#4a6f57] text-white text-[14.5px] font-medium shadow-sm">
                <Heart className="w-4 h-4 mr-1.5" /> Créer une Cagnotte Yako
              </Button>
            </div>
            <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
              <Stat value={stats.active} label="Cagnottes actives" />
              <Stat value={stats.donors} label="Donateurs" />
              <Stat value={stats.collected} label="FCFA collectés" />
            </div>
          </div>

          {/* Right visual collage */}
          <div className="lg:col-span-5">
            <div className="grid grid-cols-2 gap-3 max-w-[520px] ml-auto">
              <div className="relative rounded-3xl overflow-hidden h-[280px] bg-[#5a8268] col-span-1">
                <img src="https://images.unsplash.com/photo-1647616927583-1d44a79a38a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" alt="Célébration africaine" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent" />
                <div className="absolute bottom-3 left-3 text-white">
                  <div className="text-[10px] tracking-wider uppercase opacity-90">Joyeuse</div>
                  <div className="font-semibold mt-1">Célébrons ensemble</div>
                </div>
              </div>
              <div className="rounded-3xl bg-white border border-black/5 p-4 flex flex-col justify-between h-[280px]">
                <Heart className="w-5 h-5 text-[#d97757]" />
                <div>
                  <div className="text-[13px] text-neutral-600">Mariage, naissance, réussite, voyage…</div>
                </div>
              </div>
              <div className="rounded-3xl bg-white border border-black/5 p-4 flex flex-col justify-between h-[220px]">
                <div className="w-5 h-5 rounded-full bg-[#5a8268]/15 flex items-center justify-center">
                  <div className="w-2 h-2 rounded-full bg-[#5a8268]" />
                </div>
                <div className="text-[13px] text-neutral-600">Obsèques, maladie, soutien…</div>
              </div>
              <div className="relative rounded-3xl overflow-hidden h-[220px]">
                <img src="https://images.unsplash.com/photo-1655720359248-eeace8c709c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" alt="Solidarité africaine" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent" />
                <div className="absolute bottom-3 left-3 text-white">
                  <div className="text-[10px] tracking-wider uppercase opacity-90">Yako</div>
                  <div className="font-semibold mt-1">On est ensemble</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="text-[28px] font-semibold tracking-tight text-[#1a1d1a]">{value}</div>
      <div className="text-[12px] text-neutral-500 mt-1">{label}</div>
    </div>
  );
}
